import React from "react";
import PopupHeader from "../PopupHeader";
import DistroListSelectMembers from "../../DistroList/DistroListSelectMembers";
import useTodoSelectMemberData from "./useTodoSelectMemberData";

const TodoSelectMember = ({ popupData, closePopup }) => {
  const { members, usersByKind, onMemberChange } =
    useTodoSelectMemberData(popupData);

  return (
    <div className="bg-white p1 rounded-lg border shadow-lg">
      <PopupHeader className="border-none" closePopup={() => closePopup()} />

      <DistroListSelectMembers
        relative
        members={usersByKind}
        selectedMembers={members}
        onAdd={(val) => onMemberChange(val, "add")}
        onRemove={(val) => onMemberChange(val, "remove")}
      />
    </div>
  );
};

export default TodoSelectMember;
